import { RBTEstado } from "./rbtestado";

export class RBTDatosFecha {
    fecha:String;
    estados:RBTEstado[] =[];
    
}

